"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.TriggerButton = void 0;
var react_1 = __importDefault(require("react"));
var button_1 = require("@react-aria/button");
var utils_1 = require("@react-aria/utils");
var classnames_1 = __importDefault(require("classnames"));
var component_library_1 = require("@kaizen/component-library");
var chevron_down_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/chevron-down.icon.svg"));
var chevron_up_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/chevron-up.icon.svg"));
var context_1 = require("../../context");
var TriggerButton_module_scss_1 = __importDefault(require("./TriggerButton.module.scss"));
exports.TriggerButton = react_1["default"].forwardRef(function (_a, buttonRef) {
    var _b;
    var _c = _a.placeholder, placeholder = _c === void 0 ? "Select" : _c, classNameOverride = _a.classNameOverride, isReversed = _a.isReversed, triggerProps = _a.triggerProps, valueProps = _a.valueProps, status = _a.status, restProps = __rest(_a, ["placeholder", "classNameOverride", "isReversed", "triggerProps", "valueProps", "status"]);
    var state = (0, context_1.useSelectContext)().state;
    var value = (_b = state === null || state === void 0 ? void 0 : state.selectedItem) === null || _b === void 0 ? void 0 : _b.rendered;
    var ref = (0, utils_1.useObjectRef)(buttonRef);
    var buttonProps = (0, button_1.useButton)(triggerProps, ref).buttonProps;
    return (react_1["default"].createElement("button", __assign({ type: "button", 
        // for the eslint issue below, both of the attributes (aria-expanded and aria-controls) are on the button but it just doesn't know it
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "combobox" }, (0, utils_1.mergeProps)(buttonProps, restProps), { ref: ref, className: (0, classnames_1["default"])(TriggerButton_module_scss_1["default"].button, (value === null || value === undefined) && TriggerButton_module_scss_1["default"].placeholder, status === "error" && TriggerButton_module_scss_1["default"].error, status === "caution" && TriggerButton_module_scss_1["default"].caution, triggerProps.isDisabled && TriggerButton_module_scss_1["default"].disabled, isReversed && TriggerButton_module_scss_1["default"].reversed, classNameOverride) }),
        react_1["default"].createElement("span", __assign({}, valueProps, { className: TriggerButton_module_scss_1["default"].value }), value !== null && value !== void 0 ? value : placeholder),
        react_1["default"].createElement(component_library_1.Icon, { icon: state.isOpen ? chevron_up_icon_svg_1["default"] : chevron_down_icon_svg_1["default"], role: "presentation", classNameOverride: TriggerButton_module_scss_1["default"].icon })));
});
exports.TriggerButton.displayName = "TriggerButton";
//# sourceMappingURL=TriggerButton.js.map